import * as types from '../../../../lib/actionTypes.es6'

export const initialState = {
  errors: null,
  loader: false,

  get_PolicyProcessingDcp_errors: null,
  get_PolicyProcessingDcp_loader: false,
  get_PolicyProcessingDcp_success_message: '',
  policyProcessingDcp: null,

  customerQuotes: null,
  customerQuotesLoader: false,
  customerQuotesError: null,

  policyActionLoader: false,
  policyActionsuccess: false,
  policyActionError: null,
  policyAction: null,
  policyToApprove: null,

  policyRejectActionLoader: false,
  policyRejectActionsuccess: false,
  policyRejectActionError: null,
  policyRejectAction: null,

  makerCheckDecisionLoader: false,
  makerCheckDecisionSuccess: false,
  makerCheckDecisionError: null,
  makerCheckDecision: null,

  returnToPriorStageLoader: false,
  returnToPriorStageSuccess: false,
  returnToPriorStageError: null,
  returnToPriorStageResult: null,

  setNeedActionLoader: false,
  setNeedActionSuccess: false,
  setNeedActionError: null,
  setNeedActionDirection: null,

  quotationDecisionLoader: false,
  quotationDecisionSuccess: false,
  quotationDecisionError: null,
  quotationDecision: null,

  cancelPolicyActionErrors: null,
  cancelPolicyActionLoader: false,
  cancelPolicyActionSuccess: false,

  policyNotes: null,
  policyToView: null,
  policyNotesSuccess: false,
  policyNotesLoader: false,
  policyNotesError: null,

  deleteDocumentError: null,
  deleteDocumentLoader: false,
  deleteDocument: null,
  hardDeleteDocumentsSuccess: false,
  hardDeleteDocumentLoader: false,
  hardDeleteDocumentSuccess: false,

  documentsToDelete: null,

  get_PaymentsByPolicyGuid_errors: null,
  get_PaymentsByPolicyGuid_loader: false,
  get_PaymentsByPolicyGuid_success_message: '',
  policiesPaymentByGuid: null,

  initiatePaymentSuccess: false,
  initiatePaymentLoader: false,
  initiatePaymentError: null,

  checkoutLinkLoader: false,
  checkoutLinkUrl: null,
  checkoutLinkError: null,

  findCustomerForTransferLoader: false,
  foundCustomersForTransfer: null,
  findCustomerForTransferError: null,

  switchPolicyCustomerLoader: false,
  switchPolicyCustomerSuccess: false,
  switchPolicyCustomerError: null
}

export default function policyProcessingReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_POLICY_PROCESSING_DCP_REQUEST:
      return {
        ...state,
        get_PolicyProcessingDcp_loader: true,
        get_PolicyProcessingDcp_errors: null,
        policyProcessingDcp: null
      }
    case types.GET_POLICY_PROCESSING_DCP_SUCCESS:
      return {
        ...state,
        get_PolicyProcessingDcp_loader: false,
        get_PolicyProcessingDcp_errors: null,
        policyProcessingDcp: action.payload
      }
    case types.GET_POLICY_PROCESSING_DCP_FAILURE:
      return {
        ...state,
        get_PolicyProcessingDcp_loader: false,
        get_PolicyProcessingDcp_errors: action.payload,
        policyProcessingDcp: null
      }

    case types.GET_POLICY_PROCESSING_CUSTOMER_QUOTES_REQUEST:
      return {
        ...state,
        customerQuotesLoader: true,
        customerQuotesError: null,
        customerQuotes: null
      }
    case types.GET_POLICY_PROCESSING_CUSTOMER_QUOTES_SUCCESS:
      return {
        ...state,
        customerQuotesLoader: false,
        customerQuotesError: null,
        customerQuotes: action.payload
      }
    case types.GET_POLICY_PROCESSING_CUSTOMER_QUOTES_FAILURE:
      return {
        ...state,
        customerQuotesLoader: false,
        customerQuotesError: action.payload,
        customerQuotes: null
      }

    case types.POLICY_ACTION_REQUEST:
      return {
        ...state,
        policyActionError: null,
        policyActionLoader: true,
        policyActionsuccess: false,
        policyAction: null,
        policyToApprove: action.payload
      }

    case types.POLICY_ACTION_SUCCESS:
      return {
        ...state,
        policyAction: action.payload,
        policyActionsuccess: true,
        policyActionLoader: false,
        policyActionError: null
      }

    case types.POLICY_ACTION_FAILURE:
      return {
        ...state,
        policyActionLoader: false,
        policyActionError: action.payload
      }

    case types.RESET_POLICY_ACTION_SUCCESS:
      return { ...state, policyActionsuccess: false }

    case types.RESET_POLICY_ACTION_ERROR:
      return { ...state, policyActionError: null }

    case types.SET_POLICY_TO_APPROVE:
      return { ...state, policyToApprove: action.payload }

    case types.RESET_POLICY_TO_APPROVE:
      return { ...state, policyToApprove: null }

    case types.POLICY_REJECT_ACTION_REQUEST:
      return {
        ...state,
        policyRejectActionError: null,
        policyRejectActionLoader: true,
        policyRejectActionsuccess: false,
        policyRejectAction: null
      }

    case types.POLICY_REJECT_ACTION_SUCCESS:
      return {
        ...state,
        policyRejectAction: action.payload,
        policyRejectActionsuccess: true,
        policyRejectActionLoader: false,
        policyRejectActionError: null
      }

    case types.POLICY_REJECT_ACTION_FAILURE:
      return {
        ...state,
        policyRejectActionLoader: false,
        policyRejectActionError: action.payload
      }

    case types.MAKER_CHECK_DECISION_REQUEST:
      return {
        ...state,
        makerCheckDecisionError: null,
        makerCheckDecisionLoader: true,
        makerCheckDecisionSuccess: false,
        makerCheckDecision: null
      }

    case types.MAKER_CHECK_DECISION_SUCCESS:
      return {
        ...state,
        makerCheckDecision: action.payload,
        makerCheckDecisionSuccess: true,
        makerCheckDecisionLoader: false,
        makerCheckDecisionError: null
      }

    case types.MAKER_CHECK_DECISION_FAILURE:
      return {
        ...state,
        makerCheckDecisionLoader: false,
        makerCheckDecisionError: action.payload
      }

    case types.RESET_MAKER_CHECK_DECISION:
      return {
        ...state,
        makerCheckDecisionLoader: false,
        makerCheckDecisionSuccess: false,
        makerCheckDecisionError: null,
        makerCheckDecision: null
      }

    case types.RETURN_TO_PRIOR_STAGE_REQUEST:
      return {
        ...state,
        returnToPriorStageLoader: true,
        returnToPriorStageSuccess: false,
        returnToPriorStageError: null,
        returnToPriorStageResult: null
      }
    case types.RETURN_TO_PRIOR_STAGE_SUCCESS:
      return {
        ...state,
        returnToPriorStageLoader: false,
        returnToPriorStageSuccess: true,
        returnToPriorStageError: null,
        returnToPriorStageResult: action.payload
      }
    case types.RETURN_TO_PRIOR_STAGE_FAILURE:
      return {
        ...state,
        returnToPriorStageLoader: false,
        returnToPriorStageError: action.payload
      }
    case types.RESET_RETURN_TO_PRIOR_STAGE:
      return {
        ...state,
        returnToPriorStageLoader: false,
        returnToPriorStageSuccess: false,
        returnToPriorStageError: null,
        returnToPriorStageResult: null
      }

    // `direction` is carried through so the dialogs can name what happened —
    // sending a policy back reads differently to returning it for approval.
    case types.SET_NEED_ACTION_REQUEST:
      return {
        ...state,
        setNeedActionLoader: true,
        setNeedActionSuccess: false,
        setNeedActionError: null,
        setNeedActionDirection: action.payload ? action.payload.direction : null
      }

    case types.SET_NEED_ACTION_SUCCESS:
      return {
        ...state,
        setNeedActionLoader: false,
        setNeedActionSuccess: true,
        setNeedActionError: null
      }

    case types.SET_NEED_ACTION_FAILURE:
      return {
        ...state,
        setNeedActionLoader: false,
        setNeedActionSuccess: false,
        setNeedActionError: action.payload
      }

    case types.RESET_SET_NEED_ACTION:
      return {
        ...state,
        setNeedActionLoader: false,
        setNeedActionSuccess: false,
        setNeedActionError: null,
        setNeedActionDirection: null
      }

    case types.QUOTATION_DECISION_REQUEST:
      return {
        ...state,
        quotationDecisionError: null,
        quotationDecisionLoader: true,
        quotationDecisionSuccess: false,
        quotationDecision: null
      }

    case types.QUOTATION_DECISION_SUCCESS:
      return {
        ...state,
        quotationDecision: action.payload,
        quotationDecisionSuccess: true,
        quotationDecisionLoader: false,
        quotationDecisionError: null
      }

    case types.QUOTATION_DECISION_FAILURE:
      return {
        ...state,
        quotationDecisionLoader: false,
        quotationDecisionError: action.payload
      }

    case types.RESET_QUOTATION_DECISION:
      return {
        ...state,
        quotationDecisionLoader: false,
        quotationDecisionSuccess: false,
        quotationDecisionError: null,
        quotationDecision: null
      }

    case types.ADD_POLICY_NOTES_REQUEST:
      return {
        ...state,
        policyNotesError: null,
        policyNotesLoader: true,
        policyNotesSuccess: false,
        policyNotes: null
      }

    case types.ADD_POLICY_NOTES_SUCCESS:
      return {
        ...state,
        policyNotes: action.payload,
        policyNotesSuccess: true,
        policyNotesLoader: false,
        policyNotesError: null
      }

    case types.ADD_POLICY_NOTES_FAILURE:
      return {
        ...state,
        policyNotesLoader: false,
        policyNotesError: action.payload
      }

    case types.RESET_ADD_POLICY_NOTES_SUCCESS:
      return { ...state, policyNotesSuccess: false }

    case types.CANCEL_POLICY_ACTION_REQUEST:
      return {
        ...state,
        cancelPolicyActionErrors: null,
        cancelPolicyActionLoader: true,
        cancelPolicyActionSuccess: false
      }

    case types.CANCEL_POLICY_ACTION_SUCCESS:
      return {
        ...state,
        cancelPolicyActionSuccess: true,
        cancelPolicyActionLoader: false,
        cancelPolicyActionErrors: null
      }

    case types.CANCEL_POLICY_ACTION_FAILURE:
      return {
        ...state,
        cancelPolicyActionLoader: false,
        cancelPolicyActionErrors: action.payload
      }

    case types.DELETE_POLICY_DOCUMENT_REQUEST:
      return {
        ...state,
        loader: true,
        error: null,
        document: null,
        deleteClaimDocumentLoader: true,
        deleteDocumentError: null,
        deleteDocument: null,
        hardDeleteDocumentLoader: true
      }
    case types.DELETE_POLICY_DOCUMENT_SUCCESS:
      return {
        ...state,
        loader: false,
        deleteDocumentLoader: false,
        deleteDocument: true,
        hardDeleteDocumentLoader: false,
        hardDeleteDocumentSuccess: true
      }

    case types.DELETE_POLICY_DOCUMENT_FAILURE:
      return {
        ...state,
        loader: false,
        error: action.payload,
        deleteDocumentLoader: false,
        deleteDocumentError: action.payload,
        hardDeleteDocumentLoader: false
      }

    case types.RESET_DELETE_POLICY_DOCUMENT_SUCCESS:
      return {
        ...state,
        hardDeleteDocumentsSuccess: false,
        hardDeleteDocumentSuccess: false
      }

    case types.SET_POLICY_DOCUMENT_TO_DELETE:
      return { ...state, documentsToDelete: action.payload }

    case types.RESET_POLICY_DOCUMENT_TO_DELETE:
      return { ...state, documentsToDelete: null }

    case types.GET_PAYMENTS_BY_POLICY_GUID_REQUEST:
      return {
        ...state,
        get_PaymentsByPolicyGuid_loader: true,
        get_PaymentsByPolicyGuid_errors: null,
        policiesPaymentByGuid: null
      }
    case types.GET_PAYMENTS_BY_POLICY_GUID_SUCCESS:
      return {
        ...state,
        get_PaymentsByPolicyGuid_loader: false,
        get_PaymentsByPolicyGuid_errors: null,
        policiesPaymentByGuid: action.payload
      }
    case types.GET_PAYMENTS_BY_POLICY_GUID_FAILURE:
      return {
        ...state,
        get_PaymentsByPolicyGuid_loader: false,
        get_PaymentsByPolicyGuid_errors: action.payload,
        policiesPaymentByGuid: null
      }

    case types.INITIATE_PAYMENT_REQUEST:
      return {
        ...state,
        initiatePaymentSuccess: false,
        initiatePaymentLoader: true,
        initiatePaymentError: null
      }

    case types.INITIATE_PAYMENT_SUCCESS:
      return {
        ...state,
        initiatePaymentSuccess: true,
        initiatePaymentLoader: false,
        initiatePaymentError: null
      }

    case types.INITIATE_PAYMENT_FAILURE:
      return {
        ...state,
        initiatePaymentSuccess: false,
        initiatePaymentLoader: false,
        initiatePaymentError: action.payload
      }

    case types.RESET_INITIATE_PAYMENT:
      return {
        ...state,
        initiatePaymentSuccess: false,
        initiatePaymentLoader: false,
        initiatePaymentError: null
      }

    case types.GENERATE_POLICY_CHECKOUT_LINK_REQUEST:
      return {
        ...state,
        checkoutLinkLoader: true,
        checkoutLinkUrl: null,
        checkoutLinkError: null
      }

    case types.GENERATE_POLICY_CHECKOUT_LINK_SUCCESS:
      return {
        ...state,
        checkoutLinkLoader: false,
        checkoutLinkUrl: action.payload,
        checkoutLinkError: null
      }

    case types.GENERATE_POLICY_CHECKOUT_LINK_FAILURE:
      return {
        ...state,
        checkoutLinkLoader: false,
        checkoutLinkUrl: null,
        checkoutLinkError: action.payload
      }

    case types.RESET_POLICY_CHECKOUT_LINK:
      return {
        ...state,
        checkoutLinkLoader: false,
        checkoutLinkUrl: null,
        checkoutLinkError: null
      }

    case types.FIND_CUSTOMER_FOR_TRANSFER_REQUEST:
      return {
        ...state,
        findCustomerForTransferLoader: true,
        findCustomerForTransferError: null,
        foundCustomersForTransfer: null
      }
    case types.FIND_CUSTOMER_FOR_TRANSFER_SUCCESS:
      return {
        ...state,
        findCustomerForTransferLoader: false,
        foundCustomersForTransfer: action.payload
      }
    case types.FIND_CUSTOMER_FOR_TRANSFER_FAILURE:
      return {
        ...state,
        findCustomerForTransferLoader: false,
        findCustomerForTransferError: action.payload
      }
    case types.RESET_FIND_CUSTOMER_FOR_TRANSFER:
      return {
        ...state,
        findCustomerForTransferLoader: false,
        foundCustomersForTransfer: null,
        findCustomerForTransferError: null
      }

    case types.SWITCH_POLICY_CUSTOMER_REQUEST:
      return {
        ...state,
        switchPolicyCustomerLoader: true,
        switchPolicyCustomerSuccess: false,
        switchPolicyCustomerError: null
      }
    case types.SWITCH_POLICY_CUSTOMER_SUCCESS:
      return {
        ...state,
        switchPolicyCustomerLoader: false,
        switchPolicyCustomerSuccess: true
      }
    case types.SWITCH_POLICY_CUSTOMER_FAILURE:
      return {
        ...state,
        switchPolicyCustomerLoader: false,
        switchPolicyCustomerError: action.payload
      }
    case types.RESET_SWITCH_POLICY_CUSTOMER_SUCCESS:
      return { ...state, switchPolicyCustomerSuccess: false }
    case types.RESET_SWITCH_POLICY_CUSTOMER_ERROR:
      return { ...state, switchPolicyCustomerError: null }

    default:
      return state
  }
}
